<template>
  <el-card style="position: fixed;left: 23%;border-radius: 20px;background-color: rgba(255, 255, 255, 0.8);top: 35%;width:50%;height: 40%" shadow="always">
    <div style="margin-top: 2%;">
      <span style="font-size: 20px;font-weight: bold;text-decoration: none;">自助雷达</span>
    </div>

    <div style="margin-top: 4%;">
      <el-text style="font-weight: bold;" size="large" type="primary">卡密: </el-text><el-input v-model="card" style="background-color: rgba(255, 255, 255, 0.8);width: 56%;" placeholder="请输入你的卡密" />
    </div>
    <div style="margin-top: 2%">
      <el-button style="font-weight: bold;width: 25%" plain type="info" round @click="run">启动雷达</el-button>\
      <el-button style="font-weight: bold;width: 25%" plain type="info" round @click="closeNf">关闭雷达</el-button>\
<!--      <el-button style="font-weight: bold;width: 15%" plain type="info" round @click="queryNf">查询雷达</el-button>-->
<!--      <el-button style="font-weight: bold;width: 15%" plain type="info" round @click="getCard">获取卡密</el-button>-->

    </div>
    <div style="margin-top: 5%;">
      <span style="font-size: 35px;font-weight: bold;text-decoration: none;">{{showInfo}}</span>
    </div>
  </el-card>

</template>

<script>
export default {
  name: "NfBoard",
  data(){
    return{
      showInfo:"当前雷达状态:未开启",
      visible: false,
      payurl:"",
      card:"",
      host:"",
      port:"",
    }
  },
  methods:{
    run(){
      this.showInfo = "雷达正在开启中,请耐心等待"
      this.$axios.get( '/global/openNf',{params:{card:this.card}}).then(res => {
        this.showInfo = res.data.msg
      }).catch(()=>{
        this.showInfo = "开启失败!"
      });
    },
    closeNf(){
      this.showInfo = "雷达正在关闭中,请耐心等待"
      this.$axios.get( '/global/closeNf',{params:{card:this.card}}).then(res => {
        this.showInfo = res.data.msg
      }).catch(()=>{
        this.showInfo = "关闭失败!"
      });
    },

    queryNf(){
      this.$axios.get( '/global/queryGpsInfo',{params:{card:this.card}}).then(res => {
        if( res.data.sever !==  null && res.data.sever.includes(".")){
          this.showInfo = "http://" +  res.data.sever + ":" + res.data.port
        }
      }).catch(()=>{

      });
    }
  },
  mounted() {
    setInterval(this.queryNf, 2500);

  }
}
</script>

<style scoped>

</style>